import { render, staticRenderFns } from "./DetailCourse.vue?vue&type=template&id=4312bd5c&"
import script from "./DetailCourse.vue?vue&type=script&lang=ts&"
export * from "./DetailCourse.vue?vue&type=script&lang=ts&"
import style0 from "./DetailCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports